import { LoanQuoteTerminationTypeEnum } from '@talos/kyoko';
import { useCallback } from 'react';

import type { LoanTermTypeOption } from './productLayoutTokens';

type LoanQuoteTerminationType = (typeof LoanQuoteTerminationTypeEnum)[keyof typeof LoanQuoteTerminationTypeEnum];

/** Values this hook passes into `handleFieldChange` (no `unknown` / `any`). */
export type LoanOtcTermTypeFieldValue = LoanQuoteTerminationType | null | undefined;

export type LoanOtcTermTypeFieldChange = (
  field: 'termType' | 'term' | 'initialTerm',
  value: LoanOtcTermTypeFieldValue
) => void;

export type LoanOtcTermTypeSearchSelectOnChange = (option?: LoanTermTypeOption) => void;

/**
 * Mutual exclusivity with loan OTC Yup schemas: Open requires `term` null; Fixed requires `initialTerm` null.
 * Clearing when toggling Term Type avoids stale values.
 */
export function useLoanOtcTermTypeChange(
  handleFieldChange: LoanOtcTermTypeFieldChange
): LoanOtcTermTypeSearchSelectOnChange {
  return useCallback(
    (option?: LoanTermTypeOption) => {
      const next = option?.value;
      handleFieldChange('termType', next);
      if (next === LoanQuoteTerminationTypeEnum.OpenTerm) {
        handleFieldChange('term', null);
      } else if (next === LoanQuoteTerminationTypeEnum.Fixed) {
        handleFieldChange('initialTerm', null);
      }
    },
    [handleFieldChange]
  );
}
